import { useEffect, useRef, useState } from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAuth } from 'src/contexts/auth';

import { ModelOfFatura, ModelOfFuelType, ModelOfTipoCombustivel, ModelOfContrato, ModelOfVehicleItem } from '../../database';
import api from '../../services/api';
import { ModelOfAbastecimento } from 'src/modelreport/relabastecimento';
import { Toast } from 'primereact/toast';

const initialValuesOfFatura = {
	ID: '',
	ORGAO: '',
	DATA: '',
	FT_NEGOCIO: {
		ID: '',
		ORGAO: '',
		CNPJ: '',
		RAZAOSOCIAL: '',
		ENDERECO: '',
		CEP: '',
		BAIRRO: '',
		MUNICIPIO: '',
		EMAIL: '',
	},
	FT_CONTRATO: {
		ID: '',
		ORGAO: '',
		DATAINICIO: '',
		DATAFIM: '',
		NUMERO: '',
		TAXAADM: 0,
		DESCRICAO: '',
	},
	TAXAADM: 0,
	NUMERO: '',
	CREDOR: '',
};


export const useListFaturasController = () => {
	const [FaturasData, setFaturasData] = useState<ModelOfFatura[]>([]);
	const [selectedFatura, setSelectedFatura] = useState<ModelOfFatura>(initialValuesOfFatura);
	const [loading, setLoading] = useState(false);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const toast: any = useRef();
	const { userAgencyId } = useAuth();


	const validationSchema = Yup.object().shape({
		ID: Yup.string(),
		ORGAO: Yup.string().required('* Campo obrigatório'),
		DATA: Yup.string(),
		FT_NEGOCIO: Yup.object().shape({
			ID: Yup.string(),
			ORGAO: Yup.string(),
			CNPJ: Yup.string(),
			RAZAOSOCIAL: Yup.string(),
			ENDERECO: Yup.string(),
			CEP: Yup.string(),
			BAIRRO: Yup.string(),
			MUNICIPIO: Yup.string(),
			EMAIL: Yup.string().email('Email inválido'),
		}),
		FT_CONTRATO: Yup.object().shape({
			ID: Yup.string(),
			ORGAO: Yup.string(),
			DATAINICIO: Yup.string(),
			DATAFIM: Yup.string(),
			NUMERO: Yup.string(),
			TAXAADM: Yup.number(),
			DESCRICAO: Yup.string(),
		}),
		TAXAADM: Yup.number().required('* Campo obrigatório'),
		CREDOR: Yup.string().required('* Campo obrigatório'),
		NUMERO: Yup.string(),

	});

	const getFaturas = () => {
		setLoading(true);
		console.log("Inicio da Fatura: ", userAgencyId);

		api.get(`/faturas2/${userAgencyId}`)
			.then(response => {
				console.log("response 111 ---", response)
				if (response.status === 204) {
					setLoading(false);
				} else {
					console.log("response 222---", response)
					const faturas = response.data.map((item: any) => ({
						ID: item.ID,
						NUMERO: item.NUMERO,
						ORGAO: item.ORGAO,
						DATA: item.DATA,
						TAXAADM: item.TAXAADM,
						CREDOR: item.CREDOR,
						ORGAOUNIDADE: item.ORGAOUNIDADE,
						// Mapeia os campos flat para a estrutura esperada pelo FaturasList
						FT_NEGOCIO: {
							ID: item.FT_NEGOCIO,
							RAZAOSOCIAL: item.RAZAOSOCIAL,
						},
						FT_CONTRATO: {
							ID: item.FT_CONTRATO,
							DESCRICAO: item.DESCRICAO,
							NUMERO: item.NUMERO,
						},
					}));

					setFaturasData(faturas);
					console.log("Faturas mapeadas: ", faturas);
					setLoading(false);
				}
			})
			.catch((error: AxiosError) => {
				console.log('erro: ', error.message);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Lista de fatura não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const removeFatura = async (Fatura: ModelOfFatura) => {
		setLoading(true);
		api.delete(`faturas/${Fatura.ID}`)
			.then(response => {
				const newList = FaturasData.filter(creditor => creditor.ID !== response.data.ID);
				setFaturasData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O credor foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getFaturas();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editFatura = async (Fatura: ModelOfFatura) => {
		setLoadingEdit(true);
		const editedFatura: ModelOfFatura = {
			...Fatura,
		};
		api.put(`faturas/${selectedFatura?.ID}`, editedFatura)
			.then(() => {
				getFaturas();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O credor foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch(err => {
				getFaturas();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação! ' + err,
					life: 5000,
				});
			});
	};



	const openDeleteDialog = (Fatura: ModelOfFatura) => {
		setDeleteDialog(true);
		setSelectedFatura(Fatura);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (Fatura: ModelOfFatura) => {
		setEditDialog(true);
		setSelectedFatura(Fatura);
	};

	const criarFatura = async ({ fatura, contrato, vehicleData, toast }: { fatura: ModelOfFatura; contrato: ModelOfContrato; vehicleData: ModelOfAbastecimento[]; toast: React.RefObject<Toast>; }) => {
		setLoading(true);
		console.log("Criando fatura com os seguintes dados:", {
			fatura,
			contrato,
			vehicleData,
		});
		try {
			await api.post('faturas/', {
				userAgencyId: userAgencyId,
				fatura: fatura,
				contrato: contrato,
				abastecimentos: vehicleData,
			});
			toast.current?.show({
				severity: 'success',
				summary: 'Fatura criada',
				detail: 'A fatura foi criada com sucesso!',
				life: 5000,
			});
		} catch (error) {
			toast.current?.show({
				severity: 'error',
				summary: 'Falha ao criar fatura',
				detail: 'Ocorreu um erro ao criar a fatura! ' + error,
				life: 5000,
			});
		} finally {
			setLoading(false);
		}
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};


	const formik = useFormik<ModelOfFatura>({

		initialValues: {
			ID: '',
			ORGAO: '',
			DATA: '',
			FT_NEGOCIO: {
				ID: '',
				ORGAO: '',
				CNPJ: '',
				RAZAOSOCIAL: '',
				ENDERECO: '',
				CEP: '',
				BAIRRO: '',
				MUNICIPIO: '',
				EMAIL: '',
			},
			FT_CONTRATO: {
				ID: '',
				ORGAO: '',
				DATAINICIO: '',
				DATAFIM: '',
				NUMERO: '',
				TAXAADM: 0,
				DESCRICAO: '',
			},
			TAXAADM: 0,
			CREDOR: '',
			NUMERO: '',
		},
		validationSchema: validationSchema,
		onSubmit: async (values) => {
			console.log("valores: ", values)
			await editFatura(values)
		}

	});

	const openPrintDialog = async (fatura: ModelOfFatura) => {
		try {
			const response = await api.get(`/faturas/${fatura.ID}/relatorio`, {
				responseType: 'blob',
			});

			const url = URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.download = `fatura_${fatura.NUMERO ?? fatura.ID}.xlsx`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(url);

		} catch (error) {
			console.error('Erro ao gerar relatório:', error);
		}
	};



	useEffect(() => {
		console.log("1111111 getFaturas")
		getFaturas();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		getFaturaListController: {
			formik,
			FaturasData,
			selectedFatura,
			loading,
			deleteDialog,
			editDialog,
			loadingEdit,
			toast,
		},
		handleFaturaListController: {
			removeFatura,
			editFatura,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			getFaturas,
			criarFatura,
			openPrintDialog,
		},
	};
};
